import { Injectable } from '@angular/core';
import { getAuth, signInWithEmailAndPassword, signOut, UserCredential } from 'firebase/auth';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor() {}

  /**
   *
   * @param email The email used to verify the user in Firebase Authentication.
   * @param password The password used to verify the user in Firebase Authentication.
   * @returns A UserCredential Observable.
   */
  public login(email: string, password: string): Observable<UserCredential> {
    const auth = getAuth();
    return from(signInWithEmailAndPassword(auth, email, password));
  }

  /**
   *
   * @returns Promise for the user's sign out.
   */
  public logout(): Observable<void> {
    const auth = getAuth();
    return from(signOut(auth));
  }
}
